const paths = {
    order: '/pedidos',
    products: '/listar-produtos',
    editProduct: '/editar-produto',
    newProduct: '/novo-produto'
}

export default paths